import React from 'react';
const StepperRightArrowIcon = () => {
    return (React.createElement("svg", { width: "6", height: "10", viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M0.221252 8.4425L3.65625 5L0.221252 1.5575L1.27875 0.5L5.77875 5L1.27875 9.5L0.221252 8.4425Z", fill: "#363948" })));
};
export default StepperRightArrowIcon;
